import React from 'react';
import styled from 'styled-components';

// Define the pulse animation
const pulseAnimation = `
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;
const ShimmerWrapper = styled.div`
  width: 100%;
`;
const ShimmerChart = styled.div`
  width: 100%;
  height: 30vh;
  background-color: #fef9f9;
  border-radius: 0.375rem;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  ${pulseAnimation}
`;

const ChartDetailsShimmer = () => {
  return (
    <ShimmerWrapper>
      <ShimmerChart />
    </ShimmerWrapper>
  );
};

export default ChartDetailsShimmer;
